import * as React from 'react';
import { Paper, PaperProps } from '@mui/material';

export type GlassPanelProps = PaperProps;

export function GlassPanel({ sx, ...props }: GlassPanelProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 2.5 },
        border: '1px solid rgba(143, 155, 181, 0.22)',
        background:
          'linear-gradient(140deg, rgba(12, 18, 37, 0.86), rgba(19, 27, 52, 0.76))',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 18px 38px rgba(3, 8, 21, 0.42)',
        ...sx,
      }}
      {...props}
    />
  );
}
